import { render, staticRenderFns } from "./TemplateItemModal.vue?vue&type=template&id=20b7eb86"
import script from "./TemplateItemModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports